import { Injectable, signal, WritableSignal } from '@angular/core';

export interface ILoginSignal {
  usuario: string;
  password?: string;
  fechaNacimiento?: Date;
}

@Injectable({
  providedIn: 'root'
})
export class AuthStoreService {
  // Estas signals almacenan la data del login
  loginData: WritableSignal<ILoginSignal> = signal({} as ILoginSignal);

  constructor() {}

  public clearLoginData() {
    this.loginData.set({} as ILoginSignal);
  }
}
